package com.example.hukakmp.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window

private const val KEY_MAIN_TUTORIAL_SEEN = "main_tutorial_seen_v1"

@Composable
actual fun rememberMainTutorialStore(): TutorialStoreState {
    var seen by remember {
        mutableStateOf(window.localStorage.getItem(KEY_MAIN_TUTORIAL_SEEN) == "true")
    }

    return TutorialStoreState(
        hasSeen = seen,
        markSeen = {
            window.localStorage.setItem(KEY_MAIN_TUTORIAL_SEEN, "true")
            seen = true
        },
        reset = {
            window.localStorage.removeItem(KEY_MAIN_TUTORIAL_SEEN)
            seen = false
        },
    )
}
